module.exports = __webpack_public_path__ + "static/media/PipetteRack.23b03527.svg";